/**
 * Network component for handling throttling of events via requestAnimationFrame
 */
export default class Throttle {
  /**
   * Create a new instance of Throttle.
   *
   * @param {HTMLElement} element   Element on which throttle should be applied.
   * @param {string}      event     Event on which the throttle should be applied.
   * @param {function}    callback  Function to debounce (don't forget to bind it!).
   * @param {int}         frequency Maximum frequency at which callback should be executed.
   */
  constructor(element, event, callback, frequency = 250) {
    Object.assign(this, {
      callback,
      event,
      element,
      frequency,
      timeout: false,
    });

    // Bound events
    this.requestTick = this.requestTick.bind(this);
    this.update = this.update.bind(this);

    if (!this.callback) {
      // eslint-disable-next-line no-console
      console.error('Throttle error: you must specify a callback.');
    } else {
      this.element.addEventListener(this.event, this.requestTick);
    }
  }

  /**
   * Dispatches the event to the supplied callback
   * @private
   */
  update() {
    this.callback();
    window.clearTimeout(this.timeout);
    this.timeout = false;
  }

  /**
   * Ensures events don't get stacked
   * @private
   */
  requestTick() {
    if (!this.timeout) {
      this.timeout = window.setTimeout(() => {
        window.requestAnimationFrame(this.update);
      }, this.frequency);
    }
  }

  /**
   * Remove debouncer
   * @private
   */
  destroy() {
    this.element.removeEventListener(this.event, this.requestTick);
  }
}
